// extracted by mini-css-extract-plugin
export default {"id":"WWnNWfQzPy","confirm-input":"kJv3EYQVjC","confirmInput":"kJv3EYQVjC"};
    if(module.hot) {
      // 1627035565346
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  